(function () {
  var STORAGE_KEY = 'revoray_attribution_v1';

  var TRACK_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'creator_code'
  ];

  var CART_ATTR_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'creator_code',
    '_landing_path',
    '_landing_full',
    '_captured_at'
  ];

  var syncState = { syncing: false, lastSyncedHash: null };

  function getUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var data = {};
    var hasAny = false;

    TRACK_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        data[key] = value.trim();
        hasAny = true;
      }
    });

    if (hasAny) {
      data._landing_path = window.location.pathname;
      data._landing_full = window.location.pathname + window.location.search;
      data._captured_at = new Date().toISOString();
    }

    return hasAny ? data : null;
  }

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setStored(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function mergeData(oldData, newData) {
    // 新UTM覆盖旧UTM（适合达人链接复进站）
    return Object.assign({}, oldData || {}, newData || {});
  }

  function bootstrapAttribution() {
    var current = getUrlParams();
    var stored = getStored();
    if (current) {
      var merged = mergeData(stored, current);
      setStored(merged);
      return merged;
    }
    return stored;
  }

  function getAttribution() {
    return getStored();
  }

  function getCartAttrPayload() {
    var attr = getAttribution();
    if (!attr) return null;

    var attributes = {};
    CART_ATTR_KEYS.forEach(function (key) {
      if (attr[key]) attributes[key] = attr[key];
    });

    // 完整JSON便于排查
    attributes._attribution_json = JSON.stringify(attr);

    return attributes;
  }

  function appendParamsToUrl(href, attr) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;

      TRACK_KEYS.forEach(function (key) {
        if (attr && attr[key] && !url.searchParams.get(key)) {
          url.searchParams.set(key, attr[key]);
        }
      });

      return url.toString();
    } catch (e) {
      return href;
    }
  }

  function decorateLink(a, attr) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute('href');
    if (!href) return;
    if (href.indexOf('#') === 0) return;
    if (href.indexOf('mailto:') === 0) return;
    if (href.indexOf('tel:') === 0) return;

    var newHref = appendParamsToUrl(href, attr);
    if (newHref && newHref !== href) a.setAttribute('href', newHref);
  }

  function decorateLinks() {
    var attr = getAttribution();
    if (!attr) return;

    document.querySelectorAll('a[data-keep-utm="1"]').forEach(function (a) {
      decorateLink(a, attr);
    });
  }

  function simpleHash(obj) {
    try {
      return JSON.stringify(obj);
    } catch (e) {
      return String(Date.now());
    }
  }

  function syncCartAttributesToApi(options) {
    options = options || {};
    var force = !!options.force;

    var payload = getCartAttrPayload();
    if (!payload) return Promise.resolve({ skipped: true, reason: 'no_attribution' });

    var payloadHash = simpleHash(payload);
    if (!force && syncState.lastSyncedHash === payloadHash) {
      return Promise.resolve({ skipped: true, reason: 'already_synced' });
    }
    if (syncState.syncing) {
      return Promise.resolve({ skipped: true, reason: 'syncing' });
    }

    syncState.syncing = true;

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: payload })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update.js failed: ' + res.status);
        return res.json();
      })
      .then(function (json) {
        syncState.lastSyncedHash = payloadHash;
        return { ok: true, cart: json };
      })
      .catch(function (err) {
        console.warn('[Revoray UTM] cart attribute sync failed:', err);
        return { ok: false, error: err };
      })
      .finally(function () {
        syncState.syncing = false;
      });
  }

  function bindClickDecorator() {
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target;
        if (!el || !el.closest) return;
        var link = el.closest('a[data-keep-utm="1"]');
        if (!link) return;

        var attr = getAttribution();
        if (!attr) return;
        decorateLink(link, attr);
      },
      true
    );
  }

  function bindAddToCartSyncHints() {
    // Add to cart 后延迟同步一次，兼容抽屉购物车
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target;
        if (!el || !el.closest) return;

        var addBtn = el.closest('button[name="add"], [name="add"]');
        if (!addBtn) return;

        setTimeout(function () {
          syncCartAttributesToApi({ force: true });
        }, 700);

        setTimeout(function () {
          syncCartAttributesToApi({ force: false });
        }, 1800);
      },
      true
    );
  }

  function bindCheckoutSync() {
    // 点击 checkout 前强制写入 cart attributes
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target;
        if (!el || !el.closest) return;

        var checkoutBtn = el.closest('button[name="checkout"], [name="checkout"]');
        if (!checkoutBtn) return;

        if (checkoutBtn.dataset.revoraySyncing === '1') return;

        var payload = getCartAttrPayload();
        if (!payload) return; // 没有UTM就不拦截

        e.preventDefault();
        e.stopPropagation();

        checkoutBtn.dataset.revoraySyncing = '1';

        syncCartAttributesToApi({ force: true }).finally(function () {
          try {
            var form = checkoutBtn.form || (checkoutBtn.closest ? checkoutBtn.closest('form') : null);
            if (form) {
              HTMLFormElement.prototype.submit.call(form);
            } else {
              checkoutBtn.dataset.revoraySyncing = '';
              checkoutBtn.click();
            }
          } catch (err) {
            console.warn('[Revoray UTM] checkout submit fallback failed:', err);
            checkoutBtn.dataset.revoraySyncing = '';
          }
        });
      },
      true
    );
  }

  function bindObservers() {
    decorateLinks();
    syncCartAttributesToApi({ force: false });

    var observer = new MutationObserver(function () {
      decorateLinks();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    [500, 1200, 2000].forEach(function (delay) {
      setTimeout(function () {
        decorateLinks();
      }, delay);
    });

    window.addEventListener('load', function () {
      decorateLinks();
      syncCartAttributesToApi({ force: false });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bootstrapAttribution();
    bindClickDecorator();
    bindAddToCartSyncHints();
    bindCheckoutSync();
    bindObservers();

    window.RevorayAttribution = {
      get: function () {
        return getAttribution();
      },
      clear: function () {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
      },
      syncCart: function () {
        return syncCartAttributesToApi({ force: true });
      }
    };
  });
})();